import React from 'react';
import { Search, Settings, Users, Check } from 'lucide-react';
import { Button } from './ui/button';
import { servicesData } from '../data/mock';

const iconMap = {
  search: Search,
  settings: Settings,
  users: Users,
};

const Services = () => {
  return (
    <section id="servicios" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            ¿Cómo puedo ayudarte?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Servicios diseñados para que tu negocio sea más eficiente sin complicaciones
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {servicesData.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col h-full"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden flex-shrink-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#013139]/80 to-transparent" />
                  
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#00E5A3] rounded-xl flex items-center justify-center">
                    <IconComponent className="text-[#013139]" size={24} />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-2xl font-bold text-[#013139] mb-3 h-[64px] flex items-center">
                    {service.title}
                  </h3>

                  <p className="text-gray-600 mb-6 leading-relaxed h-[120px]">
                    {service.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-3 mb-6 flex-grow">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <Check className="text-[#00E5A3] flex-shrink-0 mt-0.5" size={18} />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Price */}
                  <div className="pt-6 border-t border-gray-100 mt-auto">
                    <p className="text-2xl font-bold text-[#013139] mb-4">
                      {service.price}
                    </p>
                    <Button
                      onClick={() => {
                        document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="w-full bg-[#013139] hover:bg-[#024F5B] text-white font-semibold"
                    >
                      Más información
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center max-w-3xl mx-auto">
          <div className="bg-[#013139] text-white p-8 rounded-2xl">
            <h3 className="text-2xl font-bold mb-4">¿No estás seguro por dónde empezar?</h3>
            <p className="text-gray-200 mb-6">
              Reserva una llamada gratuita de 30 minutos y te ayudo a identificar exactamente qué necesitas
            </p>
            <Button
              onClick={() => {
                window.open(
                  'https://calendly.com/esaezye',
                  'calendly',
                  'width=800,height=800,scrollbars=yes,resizable=yes'
                );
              }}
              className="bg-[#00E5A3] hover:bg-[#00C497] text-[#013139] font-bold"
            >
              Reserva tu llamada gratuita
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
